export enum TransactionStatusEnum {
  INITIALIZED = 'INITIALIZED',
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  REJECTED = 'REJECTED',
  ERROR = 'ERROR',
  DEPOSIT_ROLLBACK = 'DEPOSIT_ROLLBACK',
  WITHDRAW_ROLLBACK = 'WITHDRAW_ROLLBACK',
}
